export const globalErrorsZh = {
  "requestError.fallback": "操作未完成，请稍后重试；持续失败请联系管理员",
  "requestError.network": "连接未建立，请检查网络或稍后重试",
  "requestError.requestTimeout": "请求等待超时，请先确认操作结果，避免重复提交",
  "requestError.canceled": "请求已中止，请确认操作结果后再试",
  "requestError.responseInvalid": "返回结果暂时无法读取，请刷新后重试；持续失败请联系管理员",
  "requestError.retry": "操作未完成，请稍后重试",
  "requestError.authExpired": "登录已过期，请重新登录后继续",
  "requestError.unauthorized": "请先登录，再继续此操作",
  "requestError.rateLimitWait": "操作过于频繁，请等待 {wait} 秒后再试",
  "requestError.projectKicked": "你已没有此项目的访问权限，即将返回项目列表",
  "requestError.editorRoleRequired": "此操作需要编辑权限，请联系项目管理员调整角色",
  "requestError.acquire.creditInsufficient": "Credit 余额不足，请充值后再试",
  "requestError.acquire.quotaExceeded": "当前调用额度已用尽，请更换模型或联系管理员",
  "requestError.acquire.noPlatformKey": "当前模型尚未配置可用服务，请更换模型或联系管理员",
  "requestError.acquire.providerNotFound": "当前模型服务不可用，请更换模型或联系管理员",
  "requestError.acquire.providerDisabled": "当前模型服务已停用，请更换模型",
  "requestError.http.400": "提交的信息不符合要求，请检查后再试",
  "requestError.http.403": "你没有此操作的权限，请联系管理员确认访问范围",
  "requestError.http.404": "内容不存在或已被移除，请刷新列表后重新选择",
  "requestError.http.409": "当前操作存在冲突，请刷新内容后再试",
  "requestError.http.413": "上传内容过大，请压缩文件或分批上传",
  "requestError.http.415": "文件格式不支持，请转换格式后重新上传",
  "requestError.http.422": "提交的信息未通过校验，请检查填写内容和参考素材",
  "requestError.http.423": "当前账户或内容已锁定，请联系管理员确认",
  "requestError.http.429": "操作过于频繁，请稍后再试",
  "requestError.http.500": "服务处理失败，请稍后重试；持续失败请联系管理员",
  "requestError.http.502": "服务暂时无法连接，请稍后重试",
  "requestError.http.503": "服务暂时不可用，请稍后重试",
  "requestError.http.504": "服务响应超时，请先确认操作结果，避免重复提交",
  "requestError.http.4xx": "操作未被接受，请检查输入和权限后再试",
  "requestError.http.5xx": "服务暂时不可用，请稍后重试",
  "taskFailure.credit_insufficient": "Credit 余额不足",
  "taskFailure.detail.credit_insufficient": "余额不足，请充值后再试",
  "taskFailure.quota_exceeded": "调用额度已用尽",
  "taskFailure.detail.quota_exceeded": "当前调用额度已用尽，请更换模型或联系管理员",
  "taskFailure.permission": "没有操作权限",
  "taskFailure.detail.permission": "你没有此操作的权限，请联系项目管理员调整角色",
  "taskFailure.auth_expired": "登录已失效",
  "taskFailure.detail.auth_expired": "登录已失效，请重新登录后继续",
  "taskFailure.model_unavailable": "模型暂不可用",
  "taskFailure.detail.model_unavailable": "当前模型暂不可用，请更换模型；持续失败请联系管理员",
  "taskFailure.service_unavailable": "生成服务不可用",
  "taskFailure.detail.service_unavailable": "当前生成服务不可用，请更换模型或联系管理员",
  "taskFailure.service_busy": "生成服务繁忙",
  "taskFailure.detail.service_busy": "生成服务繁忙，请稍后重试",
  "taskFailure.timeout": "生成等待超时",
  "taskFailure.detail.timeout": "生成等待超时，请先查看任务状态，避免重复提交",
  "taskFailure.interrupted": "任务中断",
  "taskFailure.detail.interrupted": "任务已中断，请确认任务状态后重试",
  "taskFailure.params_invalid": "素材或参数需调整",
  "taskFailure.detail.params_invalid": "素材或参数不符合要求，请检查模型设置、素材数量、时长和格式后再试",
  "taskFailure.content_rejected": "内容未通过检查",
  "taskFailure.detail.content_rejected": "内容未通过安全检查，请调整提示词或参考素材后再试",
  "taskFailure.network": "生成连接中断",
  "taskFailure.detail.network": "生成连接中断，请稍后重试；持续失败可更换模型",
  "taskFailure.upstream_failed": "生成服务处理失败",
  "taskFailure.detail.upstream_failed": "生成服务未完成处理，请稍后重试或更换模型",
  "taskFailure.canceled": "任务已取消",
  "taskFailure.detail.canceled": "任务已取消；如仍需生成，请重新提交",
  "taskFailure.unknown": "生成失败",
  "taskFailure.detail.unknown": "生成失败，暂时无法确认原因，请稍后重试；持续失败请联系管理员",
  "taskFailure.retryHint": "请稍后重试"
};

export const globalErrorsEn = {
  "requestError.fallback": "The operation did not complete. Try again later, or contact an administrator if it persists.",
  "requestError.network": "Could not establish a connection. Check your network or try again later.",
  "requestError.requestTimeout": "The request timed out. Check the result before submitting again.",
  "requestError.canceled": "The request was interrupted. Check the result before trying again.",
  "requestError.responseInvalid": "The response could not be read. Refresh and try again, or contact an administrator.",
  "requestError.retry": "The operation did not complete. Try again later.",
  "requestError.authExpired": "Your session expired. Sign in again to continue.",
  "requestError.unauthorized": "Sign in before continuing.",
  "requestError.rateLimitWait": "Too many requests. Wait {wait} seconds before trying again.",
  "requestError.projectKicked": "You no longer have access to this project. Returning to the project list.",
  "requestError.editorRoleRequired": "Editing permission is required. Ask the project administrator to update your role.",
  "requestError.acquire.creditInsufficient": "Insufficient Credits. Add Credits before trying again.",
  "requestError.acquire.quotaExceeded": "The current usage allowance is exhausted. Choose another model or contact an administrator.",
  "requestError.acquire.noPlatformKey": "This model has no available service configured. Choose another model or contact an administrator.",
  "requestError.acquire.providerNotFound": "This model service is unavailable. Choose another model or contact an administrator.",
  "requestError.acquire.providerDisabled": "This model service is disabled. Choose another model.",
  "requestError.http.400": "The submitted information is invalid. Check it and try again.",
  "requestError.http.403": "You do not have permission. Ask an administrator to check your access.",
  "requestError.http.404": "This content does not exist or was removed. Refresh the list and select it again.",
  "requestError.http.409": "The operation conflicts with the current content. Refresh it and try again.",
  "requestError.http.413": "The upload is too large. Compress the files or upload them in smaller batches.",
  "requestError.http.415": "This file format is unsupported. Convert the file and upload it again.",
  "requestError.http.422": "Validation failed. Check the submitted information and reference media.",
  "requestError.http.423": "The account or content is locked. Contact an administrator.",
  "requestError.http.429": "Too many requests. Try again later.",
  "requestError.http.500": "The service could not complete the operation. Try again later or contact an administrator.",
  "requestError.http.502": "The service cannot be reached. Try again later.",
  "requestError.http.503": "The service is temporarily unavailable. Try again later.",
  "requestError.http.504": "The service timed out. Check the result before submitting again.",
  "requestError.http.4xx": "The operation was not accepted. Check your input and permissions.",
  "requestError.http.5xx": "The service is temporarily unavailable. Try again later.",
  "taskFailure.credit_insufficient": "Insufficient Credits",
  "taskFailure.detail.credit_insufficient": "Insufficient Credits. Add Credits before trying again.",
  "taskFailure.quota_exceeded": "Usage allowance exhausted",
  "taskFailure.detail.quota_exceeded": "The current usage allowance is exhausted. Choose another model or contact an administrator.",
  "taskFailure.permission": "Permission required",
  "taskFailure.detail.permission": "You do not have permission. Ask the project administrator to update your role.",
  "taskFailure.auth_expired": "Session expired",
  "taskFailure.detail.auth_expired": "Your session expired. Sign in again to continue.",
  "taskFailure.model_unavailable": "Model unavailable",
  "taskFailure.detail.model_unavailable": "This model is unavailable. Choose another model or contact an administrator.",
  "taskFailure.service_unavailable": "Service unavailable",
  "taskFailure.detail.service_unavailable": "The generation service is unavailable. Choose another model or contact an administrator.",
  "taskFailure.service_busy": "Service busy",
  "taskFailure.detail.service_busy": "The generation service is busy. Try again later.",
  "taskFailure.timeout": "Generation timed out",
  "taskFailure.detail.timeout": "Generation timed out. Check the task status before submitting again.",
  "taskFailure.interrupted": "Task interrupted",
  "taskFailure.detail.interrupted": "The task was interrupted. Check its status before trying again.",
  "taskFailure.params_invalid": "Check media or settings",
  "taskFailure.detail.params_invalid": "The media or settings are unsupported. Check the settings, reference count, duration and format.",
  "taskFailure.content_rejected": "Content rejected",
  "taskFailure.detail.content_rejected": "The content did not pass the safety check. Adjust the prompt or reference media.",
  "taskFailure.network": "Generation connection interrupted",
  "taskFailure.detail.network": "The generation connection was interrupted. Try again later, or choose another model.",
  "taskFailure.upstream_failed": "Generation service failed",
  "taskFailure.detail.upstream_failed": "The generation service could not complete the task. Try again later or choose another model.",
  "taskFailure.canceled": "Task canceled",
  "taskFailure.detail.canceled": "The task was canceled. Submit it again if you still need the result.",
  "taskFailure.unknown": "Generation failed",
  "taskFailure.detail.unknown": "Generation failed for an undetermined reason. Try again later, or contact an administrator.",
  "taskFailure.retryHint": "Try again later."
};
